<template>
  <figure @click="$emit('click')" :is="tag" :to="to" :style="style" :class="[baseCss, 'outline-none', setBgColor('placeholderBgColor', 'placeholderBgColorLightness'), 'outline-none', 'align-middle', 'relative', 'text-center', 'inline-block', 'ma-0', 'pa-0']">
    <icon
      v-if="!loaded"
      :provider="iconProvider"
      :name="!error ? placeholderIcon : placeholderErrorIcon"
      :color="!error ? placeholderIconColor : errorColor"
      :color-lightness="!error ? placeholderIconColorLightness : errorColorLightness" :size="placeholderIconSize"
      :style="{lineHeight: '100%'}" :class="['absolute', 'pointer-events-none', 'w-full', 'left-0', 'top-1/2', loading ? 'animate-spin' : null]" />
    <img @load="onLoad" @error="onError" v-if="source && !error" :class="['absolute', 'clip-0', 'pointer-events-none', 'opacity-0']" :hidden="!loaded" :src="source" />
  </figure>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'LazyImage',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      source: null,
      loaded: null,
      loading: false,
      error: false,
      show: false,
      baseCss: this.componentBaseCss('lazy-image')
    }
  },
  computed: {
    style () {
      return {
        aspectRatio: this.aspectRatio.replace(':', '/'),
        width: this.width,
        height: this.height,
        backgroundSize: this.cover ? 'cover' : 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundImage: this.loaded ? `url('${this.src}')` : null
      }
    }
  },
  watch: {
    src () {
      this.$forceUpdate()
    }
  },
  props: {
    tag: {
      type: String,
      default: 'figure'
    },
    to: {
      type: String
    },
    src: {
      type: String,
      required: true
    },
    placeholderIcon: {
      type: String,
      default: 'image'
    },
    placeholderErrorIcon: {
      type: String,
      default: 'cancel'
    },
    placeholderIconColor: {
      type: String,
      default: 'gray'
    },
    placeholderIconColorLightness: {
      type: [String, Number],
      default: 500
    },
    placeholderIconSize: {
      type: Number,
      default: 5
    },
    placeholderBgColor: {
      type: String,
      default: 'white'
    },
    placeholderBgColorLightness: {
      type: [String, Number],
      default: null
    },
    cover: {
      type: Boolean,
      default: true
    },
    errorColor: {
      type: String,
      default: 'red'
    },
    errorColorLightness: {
      type: [String, Number],
      default: 500
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String
    },
    aspectRatio: {
      type: String,
      default: '5:3'
    }
  },
  created () {
    document.addEventListener('scroll', this.isInViewport)
    document.addEventListener('resize', this.isInViewport)
  },
  destroyed () {
    document.removeEventListener('resize', this.isInViewport)
    document.removeEventListener('scroll', this.isInViewport)
  },
  mounted () {
    this.isInViewport()
  },
  methods: {
    isInViewport () {
      const rect = this.$el.getBoundingClientRect()
      const html = document.documentElement
      if (rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || html.clientHeight) && rect.right <= (window.innerWidth || html.clientWidth)) {
        this.loadImage()
      }
    },
    loadImage () {
      if (!this.source) {
        this.loading = true
        this.source = this.src
      }
    },
    onLoad () {
      this.loaded = true
      this.$nextTick(() => {
        setTimeout(() => {
          this.show = true
          this.loading = false
          this.$emit('loaded', {
            src: this.src,
            loaded: true
          })
        }, 50)
      })
    },
    onError () {
      this.loading = false
      this.error = true
      this.$emit('error', {
        src: this.src,
        loaded: false
      })
    }
  }
}
</script>
<style>
.bcq-lazy-image .bcq-icon
{
  transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/lazy-image/lazy-image.vue